
import AllSearchedCandidates from "components/HRFlow/candidates/AllSearchedCandidates";
import React from "react";
import { useParams } from "react-router-dom";

const AllSearchedCandidatesPage = () => {
    const { searchId } = useParams();
    return (
        <AllSearchedCandidates searchId={searchId as any} />
    );
};

export default AllSearchedCandidatesPage;